let localization = {
  loginPage: {
    loginTitle: 'SQUARE Study-Registrierung',
    loginSubtitle: 'Bitte loggen Sie sich mit Ihrem Migraine Buddy-Konto ein',
    googleLogin: 'Mit Google anmelden',
    emailLogin: 'Melden Sie sich mit E-Mail an',
    or: 'ODER',
    email: 'Migraine Buddy E-Mail',
    password: 'Migraine Buddy Passwort',
    downloadInstructionTitle: 'Sie haben kein Migraine-Buddy-Konto?',
    downloadInstructionBody:
      `1. Laden Sie Migraine Buddy für <a style="color: white; text-decoration: underline;" href="https://play.google.com/store/apps/details?id=com.healint.migraineapp&referrer=utm_source=squarestudy" target="_blank">Android</a> oder <a style="color: white; text-decoration: underline;" href="https://itunes.apple.com/app/apple-store/id975074413" target="_blank">iOS</a> herunter
      <br>
      2. Erstellen Sie ein Konto mit Ihrer E-Mail`
  },
  consentPage: {
    consentTitle: 'SQUARE-Studie',
    consentBody: 'Bitte bestätigen Sie, dass Sie an der SQUARE-Studie teilnehmen und dass Sie die Einverständniserklärung gelesen und unterzeichnet haben, die Ihnen Ihr Studienarzt gegeben hat. Wenn Sie sich für die Verknüpfung der Migraine-Buddy-App mit der SQUARE-Studie entscheiden, werden Ihre verschlüsselten Daten über Migraine Buddy mit Novartis geteilt, wie es in der Patienteninformation genauer erklärt ist.',
    agree: 'Stimme zu',
    disagree: 'Nein'
  },
  studyIdentifier: {
    studyIdentifierTitle: 'Bitte geben Sie Ihre Patientennummer an, die Sie von Ihrem Studienarzt erhalten haben.',
    studyIdentifierLabel: 'Patientennummer',
    studyGenderLabel: 'Geschlecht',
    studyGenderMale: 'Männlich',
    studyGenderFemale: 'Weiblich',
    // studyIdentifierConfirmationTitle: 'Bitte überprüfen Sie die Richtigkeit dieser Studienkennung',
    confirmationTitle: 'Bitte überprüfen Sie, ob die Informationen korrekt sind'
  },
  consentManagement: {
    studyName: 'SQUARE-Studie',
    studyDescription: `<p>Sie haben Ihr Migraine Buddy Konto erfolgreich mit der SQUARE-Studie verknüpft.</p><p>Wir wollen mit diesem Projekt untersuchen, welchen Einfluss das Medikament Aimovig auf die Lebensqualität von Migränepatienten in der Schweiz hat.</p>`,
    withdrawConsent: 'Einwilligung widerrufen',
    successWithdrawMessage: 'Sie haben die Zustimmung zur Verknüpfung der Migraine Buddy-App mit der SQUARE-Studie erfolgreich widerrufen.',
    withdrawConfirmationHeader: 'Einwilligung widerrufen',
    withdrawConfirmationBody: 'Sie ziehen Ihr Einverständnis zur Verknüpfung der Migraine-Buddy-App mit der SQUARE-Studie zurück. Bereits erfasste Daten werden analysiert, wie es in der unterschriebenen Einverständniserklärung dargestellt wird. Sollten Sie ganz von der Studie zurücktreten wollen, kontaktieren Sie bitte Ihren Studienarzt.',
    contactInfo: 'Sollten Sie Fragen zur Studie haben, so setzen Sie sich bitte mit Ihrem Studienarzt in Verbindung, der in der Patieteninformation aufgeführt ist.'
  },
  global: {
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Nächster'
  },
  genericMessages: {
    doNotRefresh: 'Um sich abzumelden, aktualisieren Sie bitte die Seite.',
    genericErrorHeader: 'Leider ist ein Fehler aufgetreten.',
    genericErrorBody: `<p>Versuchen Sie es erneut oder schicken Sie eine E-Mail an <a href="mailto:jenny@healint.com" class="primary-color"><u>jenny@healint.com</u></a>, falls Sie Hilfe brauchen.</p>`
  },
  errorMessages: {
    invalidEmail: 'Bitte geben Sie eine gültige Email-Adresse ein.',
    emptyPassword: 'Bitte geben Sie Ihr Migraine Buddy Passwort ein.',
    invalidCredentials: 'Diese Kombination aus E-Mail und Passwort ist nicht gültig. Wenn Sie Ihr Passwort vergessen haben, setzen Sie Ihr Passwort in Ihrer Migraine Buddy App zurück.',
    emptyStudyIdentifier: `<p>Bitte geben Sie Ihre Studienkennung ein.</p>`,
    invalidStudyIdentifier: `<p>Bitte überprüfen Sie, ob das Format Ihres Studienbezeichners korrekt ist.</p>`,
    emptyStudyGender: `<p>Bitte geben Sie Ihr Geschlecht an.</p>`
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/store/localization/deLocalization.js